// extracted by mini-css-extract-plugin
module.exports = {"link-wrapper":"community-section_link-wrapper__iJua3","link":"community-section_link__SoeTp"};